import { Component } from 'vue';
import UcText from '../components/uc-text.vue';
import isEditModeAvailable from './isEditModeAvailable';

let UcTiptap: Component;

export const preloadTipTap = async () => {
  if (!isEditModeAvailable) return;

  const loaders = import.meta.glob<{ default: Component }>('./uc-tiptap*.vue');
  const key = __AUTHORING__ ? './uc-tiptap-author.vue' : './uc-tiptap.vue';
  const load = loaders[key] as unknown as () => Promise<{ default: Component }>;
  if (load) {
    const mod = await load();
    UcTiptap = mod.default as Component;
  }
};

const maybeGetTiptap = (): Component => {
  // In authoring modes, prefer TipTap and bypass runtime availability flag
  if (!__AUTHORING__ && !isEditModeAvailable) return UcText;
  if (!UcTiptap) void preloadTipTap();

  return UcTiptap || UcText;
};

export default maybeGetTiptap;
